import { useCallback, useMemo } from 'react';
import { useAuth } from '@/context';
import {
  hasModulePermission,
  hasAnyReadPermission,
  checkRoutePermission,
} from '@/constants/permissions';

export function usePermissions() {
  const { user } = useAuth();

  const permissions = useMemo(() => user?.permissions || {}, [user?.permissions]);

  const hasPermission = useCallback(
    (module, action) => hasModulePermission(permissions, module, action),
    [permissions]
  );

  const canAccessRoute = useCallback(
    (routePermission) => checkRoutePermission(permissions, routePermission),
    [permissions]
  );

  const canReadAnyModule = useCallback(
    () => hasAnyReadPermission(permissions),
    [permissions]
  );

  return {
    permissions,
    hasPermission,
    canAccessRoute,
    canReadAnyModule,
  };
}

export default usePermissions;
